import dayjs from "dayjs";
import { version } from "version";

const fetchVersion = async () => {
  const currentDateTime = dayjs().format("YYYYMMDDHHmmssSSS");
  const response = await fetch(`/version?cb=${currentDateTime}`);
  if (!response.ok) {
    throw new Error("Error fetching version");
  }
  return response.text();
};

export const getIsAppNewVersion = async () => {
  // fetch version from server
  let serverVersion;

  try {
    serverVersion = await fetchVersion();

    serverVersion = serverVersion.split("'")[1];
  } catch (error) {
    console.error(error);
    return;
  }
  // compare server version to running version
  // you can add your own logic to test if the client version is actually older than the client version
  // to prevent problems when your /version endpoint delivers an old version by mistake (e.g. when it is cached)
  if (version === serverVersion) return false;
  return true;
};